import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import MatrixAssessmentBlock from "./MatrixAssessment/MatrixAssessmentBlock";
import MatrixDisplayBlock from "./MatrixDisplay/MatrixDisplayBlock";

var ListPage = /*#__PURE__*/function (_Component) {
  _inherits(ListPage, _Component);

  var _super = _createSuper(ListPage);

  function ListPage(props) {
    var _this;

    _classCallCheck(this, ListPage);

    _this = _super.call(this, props);
    _this.state = {
      assessment: [],
      descriptionMatrix: []
    };

    _this.onMatrixAssessmentUpdate.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(ListPage, [{
    key: "onMatrixAssessmentUpdate",
    value: function onMatrixAssessmentUpdate(block) {
      var assessment = this.state.assessment;
      var findBlock = assessment.find(function (findBlock) {
        return block.id == findBlock.id;
      });

      if (findBlock == null) {
        assessment.push(block);
      } else {
        findBlock.steps = block.steps;
      }

      this.setState({
        assessment: assessment
      });
    }
  }, {
    key: "onMatrixDescriptionAssessmentUpdate",
    value: function onMatrixDescriptionAssessmentUpdate(block) {
      var assessment = this.state.descriptionMatrix;
      var findBlock = assessment.find(function (findBlock) {
        return block.id == findBlock.id;
      });

      if (findBlock == null) {
        assessment.push(block);
      } else {
        findBlock.steps = block.steps;
      }

      this.setState({
        descriptionMatrix: assessment
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, this.props.matrixes.map(function (matrix) {
        return /*#__PURE__*/React.createElement("div", {
          key: matrix.id
        }, matrix.title, " ", /*#__PURE__*/React.createElement(Link, {
          to: "/editMatrix/".concat(matrix.id)
        }, "Edit"));
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "ASSESSMENT FORM"), this.props.matrixes[0].matrixBlocks.map(function (block) {
        return /*#__PURE__*/React.createElement(MatrixAssessmentBlock, {
          key: block.id,
          block: block,
          onMatrixAssessmentUpdate: _this2.onMatrixAssessmentUpdate.bind(_this2),
          type: "multiple"
        });
      }, this), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("pre", null, JSON.stringify(this.state.assessment, null, 2)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "DESCRIPTION ASSESSMENT FORM"), this.props.matrixes[1].matrixBlocks.map(function (block) {
        return /*#__PURE__*/React.createElement(MatrixAssessmentBlock, {
          key: block.id,
          block: block,
          onMatrixAssessmentUpdate: _this2.onMatrixDescriptionAssessmentUpdate.bind(_this2),
          type: "single"
        });
      }, this), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("pre", null, JSON.stringify(this.state.descriptionMatrix, null, 2)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "MATRIX DISPLAY BLOCK"), this.props.matrixes[0].matrixBlocks.map(function (block) {
        return /*#__PURE__*/React.createElement(MatrixDisplayBlock, {
          key: block.id,
          block: block
        });
      }, this)));
    }
  }]);

  return ListPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    matrixes: state.Matrix.matrixList
  };
}

export default connect(mapStateToProps, {})(ListPage);